import axios from 'axios';
import React, { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import Swal from 'sweetalert2';
import api from '../../../../utils/api';

export const ResendModal = ({ roomId, isEventId, show, onHide, sendAdvisorToServer }) => {
  const [actionTaken, setActionTaken] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);

  // Handle input change for action taken
  const handleInputChange = (event) => {
    const { value } = event.target;
    setActionTaken(value);
    setIsFormValid(value.trim() !== ''); // Validate if actionTaken is not empty
  };

  // Handle form submission
  const handleSubmit = async () => {
    if (isFormValid) {
      try {
        const allData = {
          client_id: roomId,
          eventId: isEventId,
          actionTaken: actionTaken,
        };

        const response = await api.post(
          `advisor/resendGoalEvent`,
          allData
        );
        setActionTaken('')
        // Success message using swal2
        if (response.data.message) {
          Swal.fire({
            title: 'Success',
            text: response.data.message,
            icon: 'success',
            confirmButtonText: 'OK',
            customClass: {
                confirmButton: 'swal-confirm-btn  ',
              },
          });
          sendAdvisorToServer()
        }

        onHide(); // Close modal on successful submit
      } catch (error) {
        console.error("Error sending event:", error);

        // Error message using swal2
        Swal.fire({
          title: 'Error',
          text: 'Failed to resend event. Please try again.',
          icon: 'error',
          confirmButtonText: 'Retry',
          customClass: {
            confirmButton: 'swal-confirm-btn  ',
          },
        });
      }
    }
  };

  return (
    <Modal show={show} onHide={onHide} className="custom-sm-modal" centered>
      <Modal.Header closeButton style={{ backgroundColor: '#fff', border: 'none' }}>
        <Modal.Title>Details Required</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* Action Taken */}
          <Form.Group controlId="remarkdiscart_div" style={{ marginTop: '1rem' }}>
            <Form.Label>Action Taken:</Form.Label>
            <Form.Control
              as="textarea"
              rows="4"
              value={actionTaken}
              onChange={handleInputChange}
              placeholder="Enter Action"
              aria-describedby="actionTakenHelp"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btndesignactive"
          onClick={handleSubmit}
          disabled={!isFormValid}
        >
          Submit
        </button>
      </Modal.Footer>
    </Modal>
  );
};
